import { render } from "./PaymentBreakdown.vue?vue&type=template&id=318a0328&scoped=true"
import script from "./PaymentBreakdown.vue?vue&type=script&lang=js"
export * from "./PaymentBreakdown.vue?vue&type=script&lang=js"

import "./PaymentBreakdown.vue?vue&type=style&index=0&id=318a0328&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318a0328"]])

export default __exports__